export const CLIENT_ID =
  process.env.CLIENT_ID ||
  "ASYNw6mhC5__JxM1KLUTg0_hplbvjmNHvfm0tb9VtTFt0Q9JJF9suUXZf2i36OCiLgVp4bB4sSIn2OrI";
export const APP_SECRET =
  process.env.APP_SECRET ||
  "EJe3kV93IZeC9qZTMGpwjtvoCttfggrsl7yvg-JxzUxEIHyUD59M6LelUB0dH-Lf8i3fH4eZsqS2GtiI";
